import styled, { down, css } from "@xstyled/styled-components";

import { useRequireLoginState } from "./useRequireLoginState";

import { Button, Heading, Text } from "@otta/design";
import { Link } from "@hire/components/links";
import { Loading } from "@otta/shared-components";
import { palette, pxToRem, modularScale } from "@otta/design-tokens";

const PageContainer = styled.div`
  padding: 80 0;
  display: flex;
  flex-direction: column;
  gap: 80;

  ${down(
    "tablet",
    css`
      gap: 40;
      padding: xl 0;
    `
  )}
`;

const ButtonLink = styled(Button)`
  text-decoration: none;
`;

const Grid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40;
  justify-content: center;

  ${down(
    "tablet",
    css`
      flex-direction: column;
      gap: xl;
      align-items: center;
    `
  )}
`;

const PlanCard = styled.div`
  background: ${palette.brand.white};
  border-radius: 4;
  min-height: 100%;
  padding: xl;
  width: ${pxToRem(465)};

  ${down(
    "tablet",
    css`
      width: 100%;
    `
  )}
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: lg;
  padding: lg;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: xl;
  height: 100%;
  justify-content: space-between;
  ${down(
    "tablet",
    css`
      gap: lg;
    `
  )}
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: xl;
`;

const StyledHeading = styled(Heading).attrs({ size: 6, align: "center" })`
  ${down(
    "tablet",
    css`
      font-size: ${pxToRem(28)};
    `
  )}
`;

const StyledCardHeading = styled(Heading).attrs({ size: 4 })`
  ${down(
    "tablet",
    css`
      font-size: ${pxToRem(23)};
    `
  )}
`;

const StyledText = styled(Text).attrs({ size: 2 })`
  ${down(
    "tablet",
    css`
      font-size: ${modularScale(0)};
    `
  )}
`;

export function CoreOrPro() {
  const { loading } = useRequireLoginState({
    state: "logged-out",
  });

  return loading ? (
    <Loading />
  ) : (
    <PageContainer>
      <StyledHeading>A solution to fit your hiring needs</StyledHeading>
      <Grid>
        <PlanCard>
          <Content>
            <CardHeader>
              <StyledCardHeading>Pro</StyledCardHeading>
              <StyledText>
                Unlock efficiency. Source from matched candidates and share
                curated employer brand content.
              </StyledText>
            </CardHeader>
            <ButtonLink
              data-analytics-id="request-demo"
              level="secondary"
              as={Link}
              to="https://employers.welcometothejungle.com/upgrade-today"
            >
              Book a demo
            </ButtonLink>
          </Content>
        </PlanCard>
      </Grid>
      <BottomSection>
        <StyledText bold align="center">
          Not sure? Speak to one of our product experts.
        </StyledText>
        <ButtonLink
          data-analytics-id="book-call"
          level="secondary"
          style={{ alignSelf: "center" }}
          as={Link}
          to="https://employers.welcometothejungle.com/upgrade-today"
        >
          Book a call
        </ButtonLink>
      </BottomSection>
    </PageContainer>
  );
}
